

    <div class="item">
      <svg:svg xmlns="http://www.w3.org/2000/svg" version="1.1"
               [attr.width]="width" [attr.height]="height" [attr.viewBox]="viewBox">

        <svg:path [attr.d]="vis.shape.representation.path.join(' ')" stroke-linecap="round"
                  [attr.stroke]="vis.stroke.fill" [attr.stroke-width]="vis.stroke.width"
                  [attr.fill]="vis.shape.fill"/>

        <svg:text [attr.x]="vis.text.primary.at.x" text-anchor="middle" [attr.y]="vis.text.icon.at.y"
                  [attr.font-size]="vis.text.icon.size"
                  [attr.fill]="vis.text.icon.fill">{{ vertex.abbr }}
        </svg:text>

      </svg:svg>

      <div>{{ vertex.name }}</div>
    </div>
  


// WEBPACK FOOTER //
// ./src/library/vertex-library/workflow-vertex-library-item.component.ts.WorkflowVertexLibraryItemComponent.html